import useSWR from "swr";
import axios from "axios";

const fetcher = (url) => axios.get(url).then((res) => res.data);

export function usePublicFiles(url, options = {}) {
  return useSWR(`${process.env.PUBLIC_URL}/${url}`, fetcher, {
    revalidateOnFocus: false,
    ...options,
  });
}
